import React from 'react';

import { defaultStyles } from '@aline/common';
import { AlineTooltip, ToolbarMenuTrigger } from 'src/components';
import { DeclarativeMenu } from 'src/components/declarative-menu';
import { useEditorTabStateSelector } from 'src/editor/editor-tab-state-registry';
import { useEditorLoading } from 'src/layout-engine';
import { makeStyles } from 'tss-react/mui';

import { useParagraphStylesMenu } from '../../shared/use-paragraph-styles-menu';

const useStyles = makeStyles()(theme => ({
  button: {
    height: theme.spacing(3),
    margin: theme.spacing(0, 0.75, 0, 0.75),
    width: 115,
  },
}));

export const FontStyleSelect = React.memo(function FontStyleSelectComponent(): JSX.Element {
  const editorLoading = useEditorLoading();
  const paragraphStylesMenu = useParagraphStylesMenu();
  const { classes } = useStyles();

  const activeStyleVariant = useEditorTabStateSelector(
    state => state.derived.paragraphProperties.styleVariant
  );

  const label =
    activeStyleVariant in defaultStyles
      ? defaultStyles[activeStyleVariant as keyof typeof defaultStyles].fontStyle
      : activeStyleVariant;

  return (
    <DeclarativeMenu config={paragraphStylesMenu} disabled={editorLoading}>
      {(renderProps, state) => (
        <AlineTooltip arrow title="Styles">
          <ToolbarMenuTrigger {...renderProps} className={classes.button} open={state.open}>
            {label}
          </ToolbarMenuTrigger>
        </AlineTooltip>
      )}
    </DeclarativeMenu>
  );
});
